import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-desktop-icon',
  templateUrl: 'desktop-icon.component.html'
})
export class DesktopIconComponent {
  constructor() {}
}
